import { render, staticRenderFns } from "./TablePlayerTotalBalance.vue?vue&type=template&id=e2d01292&scoped=true"
import script from "./TablePlayerTotalBalance.js?vue&type=script&lang=js&external"
export * from "./TablePlayerTotalBalance.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d01292",
  null
  
)

export default component.exports